import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SpinnerService {
  visibility: BehaviorSubject<boolean>;

  /**
   * Tracks in-flight request count so that concurrent requests don't
   * prematurely hide the spinner when only the first one completes.
   * showSpinner() increments; hideSpinner() decrements and only emits
   * false when the count reaches zero.
   */
  private _pendingRequests = 0;

  constructor() {
    this.visibility = new BehaviorSubject(false);
  }

  showSpinner(): void {
    this._pendingRequests++;
    this.visibility.next(true);
  }

  hideSpinner(): void {
    // Guard against going negative (e.g. double-hide from legacy callers)
    if (this._pendingRequests > 0) {
      this._pendingRequests--;
    }
    if (this._pendingRequests === 0) {
      this.visibility.next(false);
    }
  }
}
